import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import tokml from 'geojson-to-kml'

import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import Alert from '@material-ui/lab/Alert'
import IconButton from '@material-ui/core/IconButton'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'

import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import DeleteIcon from '@material-ui/icons/Delete'
import PersonIcon from '@material-ui/icons/Person'
import AddIcon from '@material-ui/icons/Add'

import RpcApiClient from 'datasources/RpcApiClient'

import './downloadFiles.css'

const useStyles = makeStyles((theme) => ({
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  userList: {
    '& .MuiListItemText-primary': {
      fontSize: '14px',
      maxWidth: '200px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .MuiListItemText-secondary': {
      fontSize: '12px',
      maxWidth: '200px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
}))

function UsersListDialog(props) {
  const authData = useSelector((state) => state.auth.authData)
  const userCompany = useSelector((state) => state.companyState.id)

  const [selectedUser, setSelectedUser] = useState('')
  const [userInfo, setUserInfo] = useState({ name: '', last_name: '', email: '' })
  const [addUser, setAddUser] = useState(false)
  const [loading, setLoading] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [openAdd, setOpenAdd] = useState(false)
  const [alerta, setAlerta] = useState({ bool: false, message: 'Click the download button to start' })

  const classes = useStyles()

  //   useEffect(() => {

  //   }, [])

  const resetStates = () => {
    setLoading(false)
    setAddUser(false)
    setSelectedUser('')
    setUserInfo({ name: '', last_name: '', email: '' })
    setAlerta({ bool: false, severity: '', message: '' })
  }

  const validations = (name) => {
    const condition = (element) => element.projectName === name

    return props.projects.some(condition)
  }

  const showUserData = (email) => {
    setSelectedUser(email)
    setUserInfo(props.userList.find((usr) => usr.email === email))
  }

  const findName = (email) => {
    const userName =
      props.userList.find((name) => name.email === email).name +
      ' ' +
      props.userList.find((name) => name.email === email).last_name
    return userName
  }

  const findUser = (email) => {
    const userInfo = props.userList.find((name) => name.email === email)
    setUserInfo(userInfo)
    // return userNam.
  }

  const removeUser = () => {
    setLoading(true)
    const updatedList = props.sharedUsers.filter((usr) => usr != userInfo.email)
    const body = {
      data: {
        document_id: props.selectedFile.id,
        file_name: props.selectedFile.name,
        file_type: 'shared',
        shared_list: updatedList,
        file_key: userCompany,
      },
      options: {
        action: 'update',
      },
    }
    try {
      RpcApiClient.createDocumentGeocreator(authData.jwtToken, body).then(() => {
        props.setSharedUsers(updatedList)
        props.getFiles()
        setLoading(false)
        setAlerta({ bool: true, severity: 'success', message: 'This user has been correctly removed.' })
        setTimeout(() => {
          resetStates()
          setOpenDelete(false)
        }, 3000)
      })
    } catch (err) {
      console.log(err)
      setLoading(false)
      setAlerta({ bool: true, severity: 'error', message: 'Something went wrong. Please try again.' })
      setTimeout(() => {
        resetStates()
        setOpenDelete(false)
      }, 3000)
    }
  }

  const addNewUser = (email) => {
    setLoading(true)
    const updatedList = props.sharedUsers
    const isInList = (usr) => usr === email
    if (!updatedList.some(isInList)) {
      updatedList.push(email)
      const body = {
        data: {
          document_id: props.selectedFile.id,
          file_name: props.selectedFile.name,
          file_type: 'shared',
          shared_list: updatedList,
          file_key: userCompany,
        },
        options: {
          action: 'update',
        },
      }
      try {
        RpcApiClient.createDocumentGeocreator(authData.jwtToken, body).then(() => {
          props.getFiles()
          setLoading(false)
          setAlerta({ bool: true, severity: 'success', message: 'This user has been correctly added.' })
          setTimeout(() => {
            resetStates()
            setOpenAdd(false)
          }, 3000)
        })
      } catch (err) {
        console.log(err)
        setLoading(false)
        setAlerta({ bool: true, severity: 'error', message: 'Something went wrong. Please try again.' })
        setTimeout(() => {
          resetStates()
        }, 3000)
      }
    } else {
      setLoading(false)
      setAlerta({ bool: true, severity: 'warning', message: 'This user is already added.' })
      setTimeout(() => {
        resetStates()
        setOpenAdd(false)
      }, 3000)
    }
  }

  const addDialog = (
    <Dialog
      open={openAdd}
      onClose={() => setOpenAdd(false)}
      style={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}
    >
      <IconButton size="small" component="span" onClick={() => setOpenAdd(false)} className="sf-modal-close">
        <CloseIcon />
      </IconButton>
      <div style={{ flex: '0 0 auto', margin: '0', padding: '16px 40px 10px 16px', fontSize: '14px' }}>
        <h3 style={{ marginBottom: '0px' }}>
          This user will be <b>added</b> to the access list
        </h3>
      </div>
      <DialogContent>
        {!loading ? (
          !alerta.bool ? (
            <div style={{ display: 'grid', color: '#0000008A' }}>
              <p style={{ margin: '0px' }}>
                <b>Name: </b>
                {userInfo.name + ' ' + userInfo.last_name}
              </p>
              <p style={{ margin: '0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <b>Email: </b>
                {userInfo.email}
              </p>
            </div>
          ) : (
            <Alert severity={alerta.severity}>{alerta.message}</Alert>
          )
        ) : (
          <div style={{ display: 'grid', padding: '14px 0px' }}>
            <Spin
              style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}
              tip="Loading..."
              size="large"
              indicator={<LoadingOutlined />}
            ></Spin>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {!loading ? (
          <div style={{ display: 'flex', gap: '15px', width: '150px', margin: 'auto', marginBottom: '10px' }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              disabled={alerta.bool}
              style={{ color: 'red', borderColor: 'red' }}
              onClick={() => setOpenAdd(false)}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              disabled={alerta.bool}
              style={{ color: '#03a9f4', borderColor: '#03a9f4' }}
              onClick={() => addNewUser(userInfo.email)}
            >
              Add
            </Button>
          </div>
        ) : null}
      </DialogActions>
    </Dialog>
  )

  const deleteDialog = (
    <Dialog
      open={openDelete}
      onClose={() => setOpenDelete(false)}
      style={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}
    >
      <IconButton size="small" component="span" onClick={() => setOpenDelete(false)} className="sf-modal-close">
        <CloseIcon />
      </IconButton>
      <div style={{ flex: '0 0 auto', margin: '0', padding: '16px 40px 10px 16px', fontSize: '14px' }}>
        <h3 style={{ marginBottom: '0px' }}>
          This user will be <b>removed</b> from the access list
        </h3>
      </div>
      <DialogContent>
        {!loading ? (
          !alerta.bool ? (
            <div style={{ display: 'grid', color: '#0000008A' }}>
              <p style={{ margin: '0px' }}>
                <b>Name: </b>
                {userInfo.name + ' ' + userInfo.last_name}
              </p>
              <p style={{ margin: '0px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <b>Email: </b>
                {userInfo.email}
              </p>
            </div>
          ) : (
            <Alert severity={alerta.severity}>{alerta.message}</Alert>
          )
        ) : (
          <div style={{ display: 'grid', padding: '14px 0px' }}>
            <Spin
              style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}
              tip="Loading..."
              size="large"
              indicator={<LoadingOutlined />}
            ></Spin>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {!loading ? (
          <div style={{ display: 'flex', gap: '15px', width: '150px', margin: 'auto', marginBottom: '10px' }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              disabled={alerta.bool}
              style={{ color: 'red', borderColor: 'red' }}
              onClick={() => setOpenDelete(false)}
            >
              Cancel
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              disabled={alerta.bool}
              style={{ color: '#03a9f4', borderColor: '#03a9f4' }}
              onClick={() => removeUser()}
            >
              Delete
            </Button>
          </div>
        ) : null}
      </DialogActions>
    </Dialog>
  )

  return (
    <Dialog
      open={props.openList}
      onClose={() => props.setOpenList(false)}
      style={{ fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }}
    >
      <IconButton size="small" component="span" onClick={() => props.setOpenList(false)} className="sf-modal-close">
        <CloseIcon />
      </IconButton>
      <div style={{ flex: '0 0 auto', margin: '0', padding: '16px 24px 10px 16px', fontSize: '14px' }}>
        <h3 style={{ marginBottom: '0px' }}>
          <b>Users List</b>
        </h3>
      </div>
      <DialogContent>
        <List component="nav">
          {props.sharedUsers.map((user) => (
            <ListItem style={user === authData.email ? { display: 'none' } : null}>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText primary={findName(user)} secondary={user} className={classes.userList} />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="comments"
                  color="secondary"
                  // disabled={user === authData.email ? true :false}
                  style={user === authData.email ? { display: 'none' } : null}
                  onClick={() => {
                    setOpenDelete(true)
                    findUser(user)
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        <Divider />
        <div style={{ display: 'flex' }}>
          <div className="add-user-container" style={addUser ? { height: '100px' } : { height: '0px' }}>
            <FormControl className={classes.formControl}>
              <InputLabel style={{ color: '#0000008A' }}>User</InputLabel>
              <Select
                value={selectedUser}
                onChange={(e) => showUserData(e.target.value)}
                autoWidth={true}
                label="Select User"
                style={{ width: '200px', maxWidth: '200px', alignSelf: 'center' }}
              >
                {props.userList.map((usr) => (
                  <MenuItem style={{ fontSize: '14px' }} value={usr.email}>
                    {usr.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <div style={{ display: 'flex' }}>
              <div style={{ display: 'grid' }}>
                <PersonIcon style={{ alignSelf: 'center', color: '#03a9f4' }} />
              </div>
              <div style={{ display: 'grid', marginLeft: '15px' }}>
                <p style={{ margin: '0px', maxWidth: '165px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {userInfo.name + ' ' + userInfo.last_name}
                </p>
                <p
                  style={{
                    margin: '0px',
                    fontSize: '12px',
                    color: '#0000008A',
                    maxWidth: '165px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {userInfo.email}
                </p>
              </div>
            </div>
          </div>
          <div style={{ margin: '0px 16px auto auto', display: 'grid' }}>
            {!addUser ? (
              <Tooltip title="Add" placement="left" arrow>
                <IconButton edge="end" style={{ color: '#03a9f4' }} onClick={() => setAddUser(true)}>
                  <AddIcon />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Cancel" placement="left" arrow>
                <IconButton edge="end" style={{ color: '#0000008A' }} onClick={() => resetStates()}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Add" placement="left" arrow>
              <IconButton
                edge="end"
                className="add-user-btn"
                style={selectedUser == '' ? { opacity: '0', pointerEvents: 'none', display: 'none' } : null}
                onClick={() => setOpenAdd(true)}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{ background: '#ededf0' }}>
        <div style={{ display: 'flex', gap: '15px', width: '150px', margin: 'auto', marginBottom: '10px' }}>
          <button
            style={{ margin: 'auto', width: '60px', textAlign: 'center' }}
            onClick={() => props.setOpenList(false)}
            className="files-manager-btn-cancel"
          >
            CLOSE
          </button>
        </div>
      </DialogActions>
      {deleteDialog}
      {addDialog}
    </Dialog>
  )
}

export default UsersListDialog
